import { AdminProjectAction, AdminProjectActionTypes } from '@completion/actions';
import { AdminProjectDto } from '@completion/models';

export interface AdminProjectState {
  projects: AdminProjectDto[];
}

export const initialState: AdminProjectState = {
  projects: [],
};

export function adminProjectReducer(state: AdminProjectState = initialState, action: AdminProjectAction): AdminProjectState {
  switch (action.type) {
    case AdminProjectActionTypes.AdminProjectsLoadSuccess:
      return {
        ...state,
        projects: action.projects,
      };

    case AdminProjectActionTypes.AdminProjectsClear:
      return initialState;

    default:
      return state;
  }
}
